import { render } from "./COIArticleData.vue?vue&type=template&id=e646d054"
import script from "./COIArticleData.vue?vue&type=script&lang=js"
export * from "./COIArticleData.vue?vue&type=script&lang=js"

import "./COIArticleData.vue?vue&type=style&index=0&id=e646d054&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__